<template>
  <div class="row">
    <div class="col-12" id="divToPrint" ref="content" v-if="periodos">

      <div class="col-12 mb-4" v-if="showWarning">
        <div class="message-box custom-warning-card d-flex align-items-center p-4 rounded shadow-sm">
          
          <div class="icon-wrapper mr-4">
            <i class="material-icons warning-icon">campaign</i>
          </div>

          <div class="alert-content w-100">
            <h5 class="warning-title mb-2">Aviso de Processamento</h5>
            <p class="message mb-1 text-dark">
              O relatório referente a <strong>{{ mesCorrenteFormatado }}</strong> encontra-se em fase de processamento.
            </p>
            <p class="message mb-0 text-muted">
              A versão oficial será disponibilizada para consulta após a <strong>finalização do processamento</strong>.
            </p>
          </div>
          
        </div>
      </div>

      <div class="form-row form_padrao mb-4">
        <div class="form-group flutuante col-md-12">
          <input type="text" name="nomeOperador" id="nomeOperador" required @keyup="filterValue($event)" />
          <label for="nomeOperador">Pesquisar períodos - ex: 01/2026</label>
        </div>
      </div>

      <div class="col-12">
        <div class="list-group" v-if="newObj.length > 0">
          
          <router-link 
            v-for="(boleto, index) in newObj" 
            :key="index"
            :to="{ name: 'extrato-utilizacao_beneficiario', params: { periodo: boleto.dtref } }"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center mb-2 shadow-sm border-0 rounded"
          >
            <div class="d-flex align-items-center">
              <i class="material-icons text-primary mr-3" style="font-size: 24px;">calendar_month</i>
              <div>
                <h6 class="mb-0 font-weight-bold text-dark">Competência: {{ formatarMesAno(boleto.dtref) }}</h6>
                <small class="text-muted">Clique para visualizar o detalhamento</small>
              </div>
            </div>
            
            <div>
              <span class="btn btn-sm btn-outline-primary d-flex align-items-center">
                <i class="material-icons mr-1" style="font-size: 16px;">visibility</i> Ver Detalhes
              </span>
            </div>
          </router-link>

        </div>

        <div v-else class="card border-0 py-5 d-flex justify-content-center align-items-center bg-light">
          <h5 class="text-muted"><i class="material-icons mr-2 align-middle">search_off</i> Nada Encontrado.</h5>
        </div>
      </div>

    </div>

    <div class="col-12" v-else>
      <loading />
    </div>
  </div>
</template>

<script>
import "vue-select/dist/vue-select.css";

export default {
  name: "relatorio-utilizacao",
  data() {
    return {
      relatorio: "RelatorioResumoUtilizacaoBeneficiario",
      periodoRelatorio: "AnoMesRelatorioResumoUtilizacaoBeneficiario",
      newObj: "", 
      periodos: "", 
      relatorioData: "",
      selected: "",
      showWarning: false,
      mesCorrenteFormatado: "",
      produto: {
        nome: "Relatório de Utilizações x Beneficiário ",
        id: "relatorio_utilizacao",
      },
    };
  },
  watch: {
    selected(value) {
      this.getRelatorio(value.dtref);
    },
  },
  methods: {
    formatarMesAno(periodo) {
      if (!periodo) return "";
      const partes = periodo.split('-');
      if (partes.length === 2) {
        return `${partes[1]}/${partes[0]}`;
      }
      return periodo;
    },

    setCurrentMonthDisplay() {
      const date = new Date();

      date.setDate(1);
      date.setMonth(date.getMonth() - 1);

      const monthName = date.toLocaleString('pt-BR', { month: 'long' });
      const year = date.getFullYear();
      const monthCapitalized = monthName.charAt(0).toUpperCase() + monthName.slice(1);

      this.mesCorrenteFormatado = `${monthCapitalized}/${year}`;
    },
    
    getPreviousMonth() {
      const date = new Date();
      date.setDate(1);
      date.setMonth(date.getMonth() - 1);

      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');

      return `${year}-${month}`;
    },

    filterValue(event) {
      const termo = event.target.value.trim();

      if (!termo) {
        this.newObj = this.periodos;
        return;
      }

      this.newObj = this.periodos.filter(item => {
        const dataFormatada = this.formatarMesAno(item.dtref);
        return dataFormatada.includes(termo);
      });
    },

    getRelatorio(period) {
      this.$http
        .get(
          "/api/CdlBh/" +
          this.relatorio +
          "?AnoMes=" +
          period +
          "&tipoPeriodo=0"
        )
        .then((response) => {
          this.relatorioData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getPeriodos() {
      this.$http
        .get("/api/CdlBh/" + this.periodoRelatorio)
        .then((response) => {
          
          // Correção: Ordena os dados de forma decrescente (mais recente primeiro)
          let dadosOrdenados = response.data.sort((a, b) => {
            let dataA = String(a.dtref).replace(/\//g, '-').trim();
            let dataB = String(b.dtref).replace(/\//g, '-').trim();
            
            if (dataA < dataB) return 1;
            if (dataA > dataB) return -1;
            return 0;
          });

          this.periodos = dadosOrdenados;
          // Usa o spread operator para garantir a reatividade e não referenciar o mesmo array diretamente
          this.newObj = [...dadosOrdenados]; 

          if (this.newObj && this.newObj.length > 0) {
            const itemMaisRecente = this.newObj[0];

            if (itemMaisRecente && itemMaisRecente.dtref) {
              let valorDtRef = String(itemMaisRecente.dtref);
              let ultimoPeriodoDisponivel = valorDtRef.replace(/\//g, '-').trim();
              let mesReferenciaIdeal = this.getPreviousMonth();

              if (ultimoPeriodoDisponivel < mesReferenciaIdeal) {
                this.showWarning = true;
              } else {
                this.showWarning = false;
              }
            } else {
              this.showWarning = false;
            }
          }
        })
        .catch((error) => {
          console.log("Erro ao buscar períodos:", error);
        });
    },
  },
  created() {
    this.setCurrentMonthDisplay();
    this.getPeriodos();
    this.$store.commit("UPDATE_PRODUTO", this.produto);
  },
};
</script>

<style lang="scss" scoped>
.custom-warning-card {
  background-color: #fffcf5; 
  border: 1px solid #ffeeba;
  border-left: 6px solid #ffc107; 
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 6px 12px rgba(255, 193, 7, 0.15) !important; 
  }
}

.icon-wrapper {
  background-color: #ffc107; 
  border-radius: 50%;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 8px rgba(255, 193, 7, 0.4); 

  .warning-icon {
    font-size: 38px; 
    color: #ffffff; 
  }
}

.warning-title {
  color: #856404; 
  font-weight: 700;
  font-size: 1.1rem;
}

.text-muted {
  color: #6c757d !important;
  font-size: 0.95rem;
}

.bg-warning-light {
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
}

.message-box {
  .report-logo {
    max-width: 60px;
    height: auto;
  }
}

.list-group-item {
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.1) !important;
    background-color: #f8f9fa;
    border-left: 4px solid #05428e !important;
  }
  
  h6 {
    color: #333;
  }
}
</style>